import { render, staticRenderFns } from "./ParamMotivoForm.vue?vue&type=template&id=334ead3e"
import script from "./ParamMotivoForm.vue?vue&type=script&lang=js"
export * from "./ParamMotivoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports